<template>
<div style="width: 100vw; height: 100vh;overflow-y: auto;overflow-x: hidden;background: #f6f7f8">
  <div style="position: relative">
    <img :src="doorInfo.imgPath" style="width: 100vw;height: 100vw">
    <van-icon name="arrow-left" style="position: absolute;top: 5.06vw;left: 4.8vw" @click="$router.go(-1)" color="white" size="4.27vw" />
  </div>
  <div style="border-radius: 5.33vw 5.33vw 0 0;margin-top: -29.87vw;width: 100vw;position: relative;z-index: 1;background: white">
    <div style="text-align: center;padding: 4vw 6.4vw 5.6vw;width: calc(100vw - 6.4 * 2vw);color: #505050;font-size: 5.07vw">
      {{doorInfo.sotreName}}
    </div>
    <div style="width: calc(100vw - 6.4*2vw);height: 10vw;background: #F8FBFF;padding: 0 6.4vw;justify-content: left;color: #505050;font-size: 3.73vw" class="centerBox">
      <img src="../../assets/img/doorInfo/mdbm.png" style="width: 3.47vw;margin-right: 2.15vw">
      门店编码 {{doorInfo.storeCode}}
    </div>
    <div style="width: calc(100vw - 6.4*2vw);height: 10vw;padding: 0 6.4vw;justify-content: left;color: #505050;font-size: 3.73vw" class="centerBox">
      <img src="../../assets/img/doorInfo/ylbh.png" style="width: 3.47vw;margin-right: 2.15vw">
      银联编号 {{doorInfo.orgNo}}
    </div>
    <div style="width: calc(100vw - 6.4*2vw);height: 10vw;background: #F8FBFF;padding: 0 6.4vw;justify-content: left;color: #505050;font-size: 3.73vw" class="centerBox">
      <img src="../../assets/img/doorInfo/jrsj.png" style="width: 3.47vw;margin-right: 2.15vw">
      加入时间 {{$utils.ymdDate(doorInfo.createTime, '-')}}
    </div>
    <div style="width: calc(100vw - 6.4*2vw);height: 10vw;padding: 0 6.4vw;justify-content: left;color: #505050;font-size: 3.73vw" class="centerBox">
      <img src="../../assets/img/doorInfo/lxr.png" style="width: 3.47vw;margin-right: 2.15vw">
      联系人 {{doorInfo.storeContactPeo}}
    </div>
    <div style="width: calc(100vw - 6.4*2vw);height: 10vw;background: #F8FBFF;padding: 0 6.4vw;justify-content: left;color: #505050;font-size: 3.73vw" class="centerBox">
      <img src="../../assets/img/doorInfo/lxdh.png" style="width: 3.47vw;margin-right: 2.15vw">
      联系电话 {{doorInfo.contactTel}}
    </div>
    <div style="width: calc(100vw - 6.4*2vw);height: 10vw;padding: 0 6.4vw;justify-content: left;color: #505050;font-size: 3.73vw" class="centerBox">
      <img src="../../assets/img/doorInfo/mddz.png" style="width: 3.47vw;margin-right: 2.15vw">
      门店地址 {{doorInfo.storeAddress}}
    </div>
    <div style="background: #f6f7f8;padding: 3.2vw;">
      <div style="width: 100%;height: 28.53vw;background: white;border-radius: 1.3vw">
        <div style="padding: 2.93vw;color: #505050;font-weight: bold;font-size: 3.73vw">
          门店邀请码
        </div>
        <div style="background: #f7faff;margin: 0 7.2vw;height: 12vw;font-size: 6.4vw;color: #505050; letter-spacing: 4.6vw;" class="centerBox">
         <div style="margin-left: 4vw">{{doorInfo.recommendCode}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'index',
  data: function () {
    return {
      show: false,
      icon: {
      },
      orderInfo: {
        deliveryInfo: {},
        orderItems: [],
        deliveryMsg: []
      },
      doorInfo: {},
      isFreightShow: false,
      couponShow: false,
      orderShow: false,
      userData: {}
    }
  },
  created () {
    this.listStore()
    // this.orderById()
    // this.userInfo()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    orderPop () {
      this.show = true
    },
    listStore () {
      const self = this
      let loading = self.$toast.loading({
        duration: 0
      })
      self.$request.shopCar.listStore(this.$route.query.id)
              .then((response) => {
                loading.clear()
                if (response.code === '200') {
                  self.doorInfo = response.data[0]
                } else {
                  self.$toast(response.msg)
                }
              })
    }
  }
}
</script>

<style scoped>

</style>
